function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H20V20H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4072EE",
  d: "M11.389 1.667c.505 0 .96.303 1.154.769l.374.897H15c1.84 0 3.333 1.493 3.333 3.334v6.666c0 1.841-1.492 3.334-3.333 3.334H5c-1.84 0-3.333-1.493-3.333-3.334V6.667c0-1.841 1.492-3.334 3.333-3.334h2.083l.374-.897c.194-.466.65-.77 1.154-.77h2.778zm-1.389 5c-1.84 0-3.333 1.492-3.333 3.333 0 1.84 1.492 3.333 3.333 3.333 1.84 0 3.333-1.492 3.333-3.333 0-1.84-1.492-3.333-3.333-3.333zM15.833 5c-.46 0-.833.373-.833.833 0 .46.373.834.833.834.46 0 .834-.373.834-.834 0-.46-.373-.833-.834-.833z"
}));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.128498fc.svg";
export { ForwardRef as ReactComponent };